import { REGION } from "../../const/linksection";
import { UserPreference, UserProfile, UserType } from "../../interfaces/userprofile";
import { IsEmpty, NullToString } from "../../utils/string";

export function mapResponseToUserProfile(response: any, region: string): UserProfile {

    let userProfileInfo = 
    {
        id: "",
        azureADId:"",
        fn : "",
        ln : "",
        dn : "",
        eml: "",
        dbid: "",
        custId: "",
        locId: "",
        title: "",
        companyId: "",
        companyName: "",
        usertype : {} as UserType,
        userpreference: {} as UserPreference,
        unitMeasurement: "",
        isWideAreaUser: false,
        isVHMS: false,
        isPLM: false,
        isInternationDbUser: false,
        isOnBoardedCustomer: false,
        isMultiDistributor: false,
        showComponentTrackingAcknowledgement:false,
        isActive: false,
        isApproved: false,
        isPunchOutDistributor: false,
        isPunchOutCustomer: false,
        isPunchOut: false,
        isGuestUser:false,
        isServiceUser :false,
        userClaims:"",
        telephone: '',
        priCountryCode:'',
        distributorId: 0,
        guestDistributorCode: "",
        guestBranchCode: "",
        guestZipCode: "",
        isAdmin : false,       
        defaultBookView: "None",
        defaultDateFormat: "mm/dd/yyyy",
        defaultDocumentLanguage: "English"
    };


    const checkNullOrEmpty = (value: any) => {
        return (value != null || value != "");
    }
    if (checkNullOrEmpty(response))
    {
        userProfileInfo.id = response.id;
        userProfileInfo.azureADId = response.azureADId;
        userProfileInfo.fn = response.firstName;
        userProfileInfo.ln = response.lastName;
        userProfileInfo.dn = response.displayName;
        userProfileInfo.eml = response.email;
        userProfileInfo.dbid = response.distributorCode;
        userProfileInfo.custId = response.customerId;
        userProfileInfo.locId = response.locationID;
        userProfileInfo.title = response.title;
        userProfileInfo.companyId = response.companyId;
        userProfileInfo.unitMeasurement = response.unitMeasurement;
        userProfileInfo.isWideAreaUser = response.isWideAreaUser;
        userProfileInfo.isMultiDistributor = response.isMultipleDistributorMapped;
        userProfileInfo.showComponentTrackingAcknowledgement = response.showComponentTrackingAcknowledgement;
        userProfileInfo.isVHMS = response.isVHMS;
        userProfileInfo.isPLM = response.isPLM;
        userProfileInfo.isActive = response.isActive;
        userProfileInfo.isApproved = response.isApproved;
        userProfileInfo.isPunchOut = response.isPunchOut;
        userProfileInfo.isGuestUser = response.isGuestUser??false;
        userProfileInfo.isPunchOutDistributor = response.isPunchOutDistributor;
        userProfileInfo.isPunchOutCustomer = response.isPunchOutCustomer;
        userProfileInfo.userClaims = response.userClaims;
        userProfileInfo.defaultBookView = response.defaultBookView;
        userProfileInfo.isServiceUser = response.isServiceUser;
        userProfileInfo.defaultDateFormat = response.defaultDateFormat;
        if (region == REGION.AmericaCorp) {
            userProfileInfo.isInternationDbUser = response.isInternationDbUser;
        }
        userProfileInfo.telephone = response.telephone;
        userProfileInfo.priCountryCode = response?.priCountryCode;
        userProfileInfo.distributorId = response.distributorId;
        userProfileInfo.guestBranchCode = response?.guestBranchCode;
        userProfileInfo.guestDistributorCode = response?.guestDistributorCode;
        userProfileInfo.guestZipCode = response?.guestZipCode;
        userProfileInfo.isAdmin = response.isAdmin;
        if(IsEmpty(response.displayName))
        {
            userProfileInfo.dn = NullToString(response.lastName);
            if(!IsEmpty(response.firstName))
                userProfileInfo.dn = + ", " + NullToString(response.firstName)
        }

        if (checkNullOrEmpty(response.userType))
        {
            userProfileInfo.usertype = 
            {
                id: response.userType.id,
                name: response.userType.nm
            }
        }


        if (checkNullOrEmpty(response.userpreferences))
        {
            userProfileInfo.userpreference = 
            {
                culture: response.userpreferences.languageCode,
                languageDesc: response.userpreferences.languageDesc,
                unitMeasurement: response.userpreferences.unitofMeasurement
            }
        }

        if (!IsEmpty(response.companyName)) {
            userProfileInfo.companyName = NullToString(response.companyName);           
        }
        userProfileInfo.defaultDocumentLanguage = response.defaultDocumentLanguage;
    }

    return userProfileInfo as unknown  as UserProfile;
}
